import { createPortal, useEffect } from 'preact/compat'
import clsx from 'clsx'
import { Divider } from 'libs/searchspring/components/collection/Divider'
import { FilterSort } from 'libs/searchspring/components/collection/filters/FilterSort'
import Icon from '@/components/snippets/icon/icon'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const FloatingToolbarPortal = ({ GridSelector, visible, selector }) => {
  const toolbarElement = document.getElementById(selector)
  const filterElement = document.querySelector('x-modal[data-id="filters"]')
  const { handleOpenFilters, activeFilters } = useFilters()

  const activeFilterCount = activeFilters?.size

  useEffect(() => {
    if (!toolbarElement) return

    if (visible) {
      toolbarElement.classList.add('!translate-x-0')
      return
    }

    toolbarElement.classList.remove('!translate-x-0')
  }, [visible])

  if (!toolbarElement) return null

  const handleFilterOpen = () => {
    handleOpenFilters()
    filterElement?.handleToggle()
  }

  const FloatingToolbar = () => {
    return (
          <div className={clsx('flex-items-center rounded-sm')}>
            <button onClick={handleFilterOpen} className={'btn btn-tertiary btn-inline group-data-visible:btn-primary'}>
              <Icon id="filter" className="icon-lg" />
              <span className={'text-sm uppercase flex items-center pr-3 gap-1 -mx-1'}>Filter{activeFilterCount > 0 ? <span className={'paragraph-md flex justify-center items-center bg-brand-black text-brand-white rounded-full size-6 text-center'}>{activeFilterCount}</span> : ''}</span>
            </button>
            <Divider />
            <FilterSort id='floating-sort' buttonClass='btn btn-tertiary btn-inline group-data-visible:btn-primary'/>
            <Divider />
            <GridSelector id='floating-grid' buttonClass='btn btn-tertiary btn-inline group-data-visible:btn-primary'/>
          </div>
    )
  }

  return createPortal(<FloatingToolbar />, toolbarElement)
}
